export default "__VITE_ASSET__CS457QbG__"